import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { SignDocumentApi } from "../SignDocuments/Models/Api";
import type { SignDocument } from "../SignDocuments/Models/Domain";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";

const SignDocumentTransformer: TransformerExtended<SignDocument, SignDocumentApi> = {
  ...DefaultTransformerGenerator<SignDocument, SignDocumentApi>(),

  toDomain(input: SignDocumentApi): SignDocument {
    const res = camel<SignDocumentApi, SignDocument>(input);

    res.responses = input.responses;

    return res;
  },
};

export type SignDocumentTransformerType = TransformerExtended<SignDocument, SignDocumentApi>;

export default SignDocumentTransformer;
